import { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'components/UI/Modal/Modal';
import { makePrimaryAddress } from 'services/UserAccountService';
import { Button } from 'components/UI/Button/Button';
import { Link } from 'components/UI/Link/Link';
import { ReactComponent as SeatIcon } from 'assets/icons/svgs/icon-approved.svg';
import { mapFieldsToAPI } from '../delivery-address-form-utils';

/**
 * Make Primary Address Confirmation Modal
 * @param {*} props
 * @usage
 * <MakePrimaryPrompt
 *  address={myaddress}
 *  active={true}
 * />
 */
export const MakePrimaryPrompt = (props) => {
  const { active, address, onRequestClose, getValues } = props;

  if (!address) {
    return null;
  }

  const [isBusy, setIsBusy] = useState(false);
  const [itemsRemoved, setItemsRemoved] = useState(false);
  const [error, setError] = useState(null);

  const closeModalHandler = () => {
    onRequestClose();
    window.location.reload();
  };

  /**
   * Handle Delete seats requests confirmed by user
   */
  const handlePrimaryConfirmed = async () => {
    if (!address.addressId) {
      // TODO: Save it first?
    }

    try {
      setIsBusy(true);
      const values = getValues();
      const payload = mapFieldsToAPI(values);
      payload.PrimaryAddress = {
        ...payload.PrimaryAddress,
        PrimaryIndicator: false,
      };
      payload.SecondaryAddresses[address.index] = {
        ...payload.SecondaryAddresses[address.index],
        PrimaryIndicator: true,
      };

      await makePrimaryAddress(payload);
      setIsBusy(false);
      setItemsRemoved(true);
    } catch (e) {
      console.error(e);
      setIsBusy(false);
      setError(e);
    }
  };

  return (
    <Modal
      open={active}
      closeModalHandler={closeModalHandler}
      extendClass="red-box padding-30 cart-remove-prompt"
    >
      <div className="text-center">
        <p>
          Just checking - do you really want to make
          <br />
          <strong>
            {address.deliveryAddress1 && `${address.deliveryAddress1}, `}
            {address.deliveryAddress2 && `${address.deliveryAddress2}, `}
            {address.suburb && `${address.suburb}, `}
            {address.stateDescription && `${address.stateDescription} `}
            {address.postcode && `${address.postcode}, `}
            {address.country && `${address.country}`}
          </strong>{' '}
          the Primary Address for your account?
        </p>

        {!itemsRemoved && !error && (
          <Button
            onClick={handlePrimaryConfirmed}
            disabled={isBusy}
            variant="primary"
            extendClass="btn-small"
            text={isBusy ? 'Processing...' : 'Yes, change the Primary Address'}
          />
        )}

        {/* Success Banner */}
        {itemsRemoved && (
          <span className="btn action-complete">
            <SeatIcon /> Primary Address changed
          </span>
        )}

        <section>
          <Link
            href="#"
            variant="primary"
            onClick={closeModalHandler}
            extendClass="modal-link link-font-bold"
          >
            {itemsRemoved ? 'Close' : 'Cancel'}
          </Link>
        </section>
      </div>
    </Modal>
  );
};

MakePrimaryPrompt.propTypes = {
  active: PropTypes.bool.isRequired,
  address: PropTypes.object,
  onRequestClose: PropTypes.func.isRequired,
  getValues: PropTypes.func.isRequired,
};
